import { chunk } from "lodash-es";
import { PATH_API } from "constants/api";
import { ApiResponse } from "interfaces/models/api";
import {
  GetInspectionContentList,
  InspectionContent,
  InspectionContentDTO,
  UpdateInspectionContent,
} from "interfaces/models/inspectionContent";
import { InspectionItem } from "interfaces/models/inspectionItem";
import { InspectionItemResult } from "interfaces/models/inspectionItemResult";
import { axiosECS } from "services/baseAxios";
import { getInspectionItems } from "./inspectionItemApi";
import { getInspectionItemResults } from "./inspectionItemResultApi";
import CacheService from "libs/cache-project/classes/CacheService";

const pathV2 = PATH_API.INSPECTION_CONTENT;

export const getInspectionContents = async (
  params?: GetInspectionContentList,
  cacheService?: CacheService
): Promise<ApiResponse<InspectionContentDTO[]>> => {
  const response = await axiosECS.get(pathV2, {
    params,
  });

  if (params?.shouldCache) {
    await cacheInspectionContent(response.data, cacheService);
  }

  return response;
};

export const updateInspectionContent = async (
  params: UpdateInspectionContent
): Promise<
  ApiResponse<{
    inspectionContent?: InspectionContent;
    contentItems?: InspectionItem[];
    itemResults?: InspectionItemResult[];
    deleteInspectionItemIds?: string[];
    deleteItemResultIds?: string[];
  }>
> => {
  return axiosECS.patch(`${pathV2}`, params);
};

export const cacheInspectionContent = async (
  contents: InspectionContentDTO[],
  cacheService?: CacheService
) => {
  for (const content of contents) {
    const { data: items } = await getInspectionItems({
      inspectionTypeId: content.inspectionTypeId,
      shouldCache: true,
    });
    const chunks = chunk(items, 5);
    for (const groups of chunks) {
      if (cacheService?.isCancel()) throw new Error();
      await Promise.all(
        groups.map(() => {
          return getInspectionItemResults({
            inspectionTypeId: content.inspectionTypeId,
            shouldCache: true,
          });
        })
      );
    }
  }
};
